const valueAsNumber = {
  to: value => parseInt(value),
  from: value => `${value}`
}

const valueAsReference = {
  to: value => ({ id: parseInt(value) }),
  from: value => `${value.id}`
}

const valueAsFns = {
  number: valueAsNumber,
  reference: valueAsReference
}

export const useValueAs = ({ value, onChange, isArray, isEvent, valueAs, nullValue = null }) => {
  if (!valueAs) {
    return {
      value: value === null ? nullValue : value,
      onChange
    }
  }

  const { to, from } = typeof valueAs === 'string' ? valueAsFns[valueAs] : valueAs

  return {
    value:
      value === undefined
        ? undefined
        : value === null
        ? nullValue
        : isArray
        ? value?.map(from)
        : from(value),
    onChange: isArray
      ? value => onChange(value?.map(to))
      : value =>
          onChange(
            isEvent
              ? value.target.value === null
                ? nullValue
                : to(value.target.value)
              : value === null
              ? nullValue
              : to(value)
          )
  }
}
